import { render, staticRenderFns } from "./collect-pin.vue?vue&type=template&id=17f651eb"
import script from "./collect-pin.vue?vue&type=script&lang=js"
export * from "./collect-pin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports